var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7399 10.2864C13.1245 10.9738 12.6418 11.833 11.8738 11.833H1.87613C1.10661 11.833 0.626152 10.9725 1.00994 10.2864L6.00882 1.34831C6.39355 0.660617 7.35715 0.661863 7.74119 1.34831L12.7399 10.2864ZM6.875 8.43848C6.34573 8.43848 5.91667 8.88095 5.91667 9.42676C5.91667 9.97257 6.34573 10.415 6.875 10.415C7.40427 10.415 7.83334 9.97257 7.83334 9.42676C7.83334 8.88095 7.40427 8.43848 6.875 8.43848ZM5.96515 4.88612L6.11969 7.808C6.12692 7.94472 6.23655 8.05176 6.36932 8.05176H7.38069C7.51346 8.05176 7.62309 7.94472 7.63032 7.808L7.78486 4.88612C7.79267 4.73844 7.67865 4.61426 7.53523 4.61426H6.21475C6.07134 4.61426 5.95734 4.73844 5.96515 4.88612Z",
    fill: "#DC8809"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingico);
export default __webpack_public_path__ + "static/media/pendingico.b880d52605faeb5da97a93cdf7e14a2b.svg";
export { ForwardRef as ReactComponent };